import React from 'react';

interface RemindersIconProps {
    gap: GapType | RiskGapType;
}
export function RemindersIcon({ gap }: RemindersIconProps) {
    const [iconHover, setIconHover] = React.useState(false);
    return (
        <div>
            <button
                type="button"
                className={`reminder-icon mt-2${gap?.tasks?.length === 0 ? ' no-reminders' : ''}`}
                title="Reminder"
                onMouseEnter={() => setIconHover(true)}
                onMouseLeave={() => setIconHover(false)}
                onFocus={() => setIconHover(true)}
                onBlur={() => setIconHover(false)}
            >
                {gap?.tasks?.length > 0 ? (
                    <i className={`fa-${!iconHover ? 'regular' : 'solid'} fa-bell`} />
                ) : (
                    <i className="fa-regular fa-bell no-reminders" />
                )}
            </button>
        </div>
    );
}
